import * as SystemActions from '../actions/system'

function getTenantFromUrl() {
  const pathSegments = window.location.pathname.split('/').filter(Boolean)
  const firstSegment = pathSegments[0] ? pathSegments[0].toLowerCase() : null
  const env = window.env || {}
  const tenants = env.tenants || []
  if (firstSegment && tenants.indexOf(firstSegment) !== -1) {
    return firstSegment
  }
  return null
}

function getDefaultTenant() {
  const env = window.env || {}
  const tenants = env.tenants || []
  return tenants[0] || null
}

const initialState = {
  tenant: getTenantFromUrl() || window.localStorage.getItem('tenant') || getDefaultTenant(),
  timeZones: JSON.parse(window.localStorage.getItem('timeZones')) || [],
}

export default (state = initialState, action) => {
  switch (action.type) {
  case SystemActions.SET_TENANT:
    return {
      ...state,
      tenant: action.tenant
    }

  case SystemActions.SET_TIMEZONES:
    return {
      ...state,
      timeZones: action.timezones
    }

  default:
    return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/system.js